import Vue from 'vue'
import App from './App.vue'
import router from './router'
import './plugins/element.js'
import i18n from './lang/index'
import ElementUI from 'element-ui'

//jq
import $ from 'jquery';
window.$ = $;

Vue.use(ElementUI)
Vue.config.productionTip = false
// 路由跳转后，页面回到顶部
router.afterEach(() => {
  document.body.scrollTop = 0;
  document.documentElement.scrollTop = 0;
})
new Vue({
  router,
  i18n,
  render: h => h(App)
}).$mount('#app')
